export enum ExerciseType {
  Warm = "warm",
  Cardio = "cardio",
  Strength = "strength",
  Functional = "functional",
  Stretching = "stretching",
  Others = "others",
}
